import { type MediaType } from '@/common/types';
import { FILE_SIZE_LABELS } from '@/common/constants';

function getTypeByMimetype(file: File): MediaType {
	if (file.type.startsWith('image')) {
		return 'image';
	}

	if (file.type.startsWith('video')) {
		return 'video';
	}

	return 'document';
}

function createName(type: MediaType, extension: string) {
	const formatter = new Intl.DateTimeFormat('ru', {
		day: 'numeric',
		month: 'numeric',
		year: 'numeric'
	});

	const result = formatter.formatToParts(new Date());

	const year = result.find((r) => r.type === 'year');
	const month = result.find((r) => r.type === 'month');
	const day = result.find((r) => r.type === 'day');
	const hour = result.find((r) => r.type === 'hour');
	const minute = result.find((r) => r.type === 'minute');
	const second = result.find((r) => r.type === 'second');

	return `${type}_${year}-${month}-${day}_${hour}-${minute}-${second}.${extension}`;
}

function getExtensionByName(name: string): string {
	const res = name.split('.');
	return res[res.length - 1];
}

function convertToMB(size: number, precision = 2) {
	if (size === 0) return '0 Байт';
	const factor = 1024;
	const index = Math.floor(Math.log(size) / Math.log(factor));

	return (
		(size / Math.pow(factor, index)).toFixed(precision) +
		' ' +
		FILE_SIZE_LABELS[index]
	);
}

function download(fileName: string, url: string | undefined) {
	const body = document.body;
	const a = document.createElement('a');
	a.href = url as string;
	a.download = fileName;
	body.appendChild(a);
	a.click();
	body.removeChild(a);
}

export default {
	download,
	createName,
	convertToMB,
	getTypeByMimetype,
	getExtensionByName
};
